import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dialog", "redoCheckbox", "submitButton"]

  open() {
    if (this.hasDialogTarget) {
      this.dialogTarget.showModal()
    }
  }

  close() {
    if (this.hasDialogTarget) {
      this.dialogTarget.close()
    }
  }

  submitEnd(event) {
    if (event.detail.success) {
      this.close()
    }
  }

  toggleRedo() {
    if (this.hasRedoCheckboxTarget && this.hasSubmitButtonTarget) {
      const isRedo = this.redoCheckboxTarget.checked
      this.submitButtonTarget.value = isRedo
        ? "Discard & Send Back to Redo"
        : "Discard Response"
    }
  }
}
